var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-wrapper"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.tips),expression:"tips"}],staticClass:"tips",style:({ left: _vm.left + 'px' }),domProps:{"textContent":_vm._s(_vm.tips)}}),_c('div',{staticClass:"bar",on:{"click":_vm.onClick,"mousemove":_vm.onMousemove,"mouseout":_vm.onMouseout}},[_c('span',{style:({
        width: _vm.per + '%',
        background: _vm.color
      })})])])}
var staticRenderFns = []

export { render, staticRenderFns }